import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { get } from 'lodash-es';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { InventoryEntities } from 'client/data/models/inventory';
import { fireListTracking } from 'client/engagement-handlers/list-engagement-handler/list-engagement-handler';
import { SHOWN_ALL_PHOTOS_COUNT } from 'site-modules/inventory/constants/inventory-thumbnails';
import { getFirstVehicle } from 'client/engagement-handlers/inventory-engagement-handler/tracking-payload-builder';
import { InventoryThumbnail } from './inventory-thumbnail';

const CREATIVE_ID = 'edm-inventory-hero-thumbnail';

export function InventoryThumbnailsRow({
  photoUrls,
  photoCount = 0,
  title,
  onThumbnailClick,
  onIndexChange,
  vinData,
  photoType,
}) {
  useEffect(() => {
    fireListTracking(
      [vinData],
      CREATIVE_ID,
      {
        photo_type: photoType,
        match_total: photoCount,
        match_result: SHOWN_ALL_PHOTOS_COUNT,
      },
      getFirstVehicle
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const vin = get(vinData, 'vin', '');
  const bodyType = get(vinData, 'vehicleInfo.styleInfo.bodyType', '');
  const photosToDisplay = photoUrls.slice(0, SHOWN_ALL_PHOTOS_COUNT);

  const handleThumbnailButtonClick = useCallback(
    index => () => {
      EventToolbox.fireTrackAction({
        event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
        event_data: {
          action_name: TrackingConstant.ACTION_VIEW_PHOTO,
          subaction_name: 'open_photoflipper_thumbnail',
          action_category: TrackingConstant.USER_ACTION_CATEGORY,
          action_cause: TrackingConstant.ACTION_CAUSE_LINK_CLICK,
          value: index + 1,
          creative_id: 'edm-inventory-hero-thumbnails',
        },
      });
      onIndexChange(index + 1);
      onThumbnailClick();
    },
    [onIndexChange, onThumbnailClick]
  );

  return (
    <Row className="mt-0_5 px-0_25">
      {photosToDisplay.map((url, index) => (
        <Col xs={3} className="px-0_25" key={url} style={{ flex: '0 0 25%', maxWidth: '25%' }}>
          <InventoryThumbnail
            title={`${title} thumbnail ${index + 1}`}
            url={url}
            onClick={handleThumbnailButtonClick(index)}
            vin={vin}
            bodyType={bodyType}
          />
        </Col>
      ))}
    </Row>
  );
}

InventoryThumbnailsRow.propTypes = {
  photoUrls: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  photoCount: PropTypes.number,
  onThumbnailClick: PropTypes.func.isRequired,
  onIndexChange: PropTypes.func.isRequired,
  vinData: InventoryEntities.InventoryVin.isRequired,
  photoType: PropTypes.string.isRequired,
};
